import {string, shape, number} from 'prop-types';

const PetInfoResourceType = {
  labels: shape({
    petName: number,
    clinicRecordNumber: string,
    mealsPerDay: string,
  }),
};

export default PetInfoResourceType;
